var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinnerArc96(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arc"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M48 3.5C59.8021 3.5 71.1209 8.18838 79.4663 16.5337C87.8116 24.8791 92.5 36.1979 92.5 48",
    stroke: "#FF4400",
    strokeWidth: 7,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerArc96);
export default __webpack_public_path__ + "static/media/spinner-arc-96.d71f3ed889d7368f660fd7afb1ebeff8.svg";
export { ForwardRef as ReactComponent };